import React from 'react';
import CheckIn from '../Components/Sessions/CheckIn';



export function Arrived() { 

    return (
      <>  
        <CheckIn />
      </>
);
   };

